export default "__VITE_ASSET__BAo_3kSg__"